export const isElementInView = (element: HTMLDivElement, bottomThreshold?: number) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.top < window.innerHeight - (window.innerHeight * (bottomThreshold ? bottomThreshold : 10)) / 100 &&
    rect.bottom >= 0
  )
}
